import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthCoverBgNewPassword() {
	return <AuthShell variant="cover-bg"><AuthForm variant="cover-bg" mode="new-password" /></AuthShell>;
}

export default AuthCoverBgNewPassword;
